import React, { useEffect, useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { showErrorToast } from '../state/toasts'
import { Loading } from '../components'
import { AuthenticationService } from '../services'

export const UserAccountApprove = (props) => {
  const dispatch = useDispatch()
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(null)
  useEffect(() => {
    setLoading(true)
    AuthenticationService.approveUserAccount(props).then(
      (response) => {
        setLoading(false)
        setResponse(response)
      },
      (errors) => {
        setLoading(false)
        dispatch(
          showErrorToast(
            `Error while performing user account  approved `,
            JSON.stringify(errors)
          )
        )
      }
    )
  }, [dispatch, props])

  return (
    <ReactBootstrap.Row style={{ marginTop: '200px' }}>
      <ReactBootstrap.Col xs={12} md={4} className={'offset-md-4'}>
        {loading ? <Loading /> : ''}
        {response && (
          <div
            className={
              response.flag
                ? 'card bg-success text-white'
                : 'card bg-danger text-white'
            }
          >
            <div class="card-body text-center">{response.detail}</div>
          </div>
        )}
      </ReactBootstrap.Col>
    </ReactBootstrap.Row>
  )
}
